import EPG from 'Utils/epgUtils';

export const preFetchEPG = async (api) => {
    const params = {
        list: EPG.DEFAULT_LIST_MODE,
        limit: EPG.DEFAULT_EPG_LIMIT,
        offset: EPG.INITIAL_EPG_OFFSET,
        ...EPG.getDateInterval(new Date())
    };

    try {
        // api.js handles the caching
        await api.fetchChannelsBrief({ list: EPG.DEFAULT_LIST_MODE });
        await api.fetchEpg(params);
    } catch (error) {
        console.log('EPG PREFETCH FAILED');
        console.log(error);
    }
};
